export const PAYMENT_APPROVAL_SELECTION_FOOTER_APPROVE_BUTTON_ID = 'payment-approval-selection-footer-approve-button';

export const WORKFLOW_SETTINGS_RELPATH = '../../settings/approval-workflows';
export const COLLABORATORS_SETTINGS_RELPATH = '../../settings/collaborators';
